<template>
  <div style="position: relative;">
    <div dir="rtl" class="page" style="height: 100%;">
      <div dir="ltr">
        <template v-for="(item, key) in messageList">
          <br />
          <div class="message-item" :key="key">
            <h1>{{ item.Title }}</h1>
            <p v-html="item.Content"></p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Message',
  mounted() {
    // _hmt.push(['_trackEvent', 'Message', 'Read']);
    this.ASetHistory('message').then((flag) => {
      if (flag) {
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send('Activity-5118-Message');
        this.$store.state.message.isNew = false;
        localStorage.setItem('message_isnew', 2);
      }
    });
  },
  computed: {
    messageList: {
      get() {
        return this.$store.state.message.messageList;
      },
      set(val) {
        this.$store.state.message.messageList = val;
      },
    },
  },
  methods: {
    ...mapActions('menu', ['ASetHistory']),
  },
};
</script>

<style type="text/less" lang="less" scoped>
@import '../assets/style/color';
@import '../assets/style/config';
@import '../assets/style/mixin';

.message-item {
  padding-bottom: 15px;
  border-bottom: 1px dashed rgb(204, 204, 204);
  h1 {
    font-size: 16px;
    font-weight: 600;
  }
  p {
    font-size: 12px;
    line-height: 25px;
  }
}
</style>
<style type="text/less" lang="less">
.message-item {
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Message.vue